<template>
    <div class="rectify-submit-dialog">
        <el-dialog title="提交整改任务" :visible.sync="isSubmitDialog" width="550px" :before-close="closeDialog">
            <el-form ref="form" :model="form" :rules="rules" size="mini" style="font-size: 14px;">
                <el-form-item prop="taskMethod">
                    <el-input type="textarea" :disabled="!isAction" placeholder="在此输入整改方法" :rows="5" v-model="form.taskMethod" maxlength="200" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <div class="tip-box">
                <p class="examine-table-title">证明文件</p>
                <Upload :text="'上传'" v-if="isAction" :uploadDisplayType="'iconAndText'" @uploadSuccess="uploadSuccess"></Upload>
            </div>
            <el-table :data="fileTableData" border height="150" style="width: 100%">
                <el-table-column label="附件名称" prop="fileName" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <span class="tab-tbn">
                            <el-button type="text" @click="previewBtn(scope.row)">预览</el-button>
                        </span>
                        <span class="tab-tbn">
                            <el-button type="text" @click="downloadBtn(scope.row)">下载</el-button>
                        </span>
                        <span class="tab-tbn" v-if="isAction">
                            <el-button type="text" @click="delBtn(scope.row,scope.$index)">删除</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <p class="examine-table-title">历史记录</p>
            <el-table :data="row.examineDerateList" border height="150" style="width: 100%">
                <el-table-column label="时间" prop="createTime" align="center" width="150px"></el-table-column>
                <el-table-column label="操作人" prop="createUserName" align="center" width="100px"></el-table-column>
                <el-table-column label="操作类型" align="center" width="80px">
                    <template slot-scope="scope">
                        <m-select class="dict-select" :value="scope.row.derateStatus" :optionNum="'SRM_PERFOR_OPERATE_TYPE'" disabled></m-select>
                    </template>
                </el-table-column>
                <el-table-column label="原因" prop="examineReason" align="center">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top" width="200">
                            <span>{{ scope.row.examineReason }}</span>
                            <div slot="reference" class="name-wrapper">{{ scope.row.examineReason }}</div>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="isAction" @click="closeDialog">取 消</el-button>
                <el-button v-if="isAction" type="primary" @click="confirm" :loading="loadConfirm">确 定</el-button>
                <el-button v-if="!isAction" @click="closeDialog">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Upload from '../../../../components/upload/Index';
import mSelect from '@/components/lots/otpSelect2/index';
import { rectifySubmit, fileList } from '../../../../api/achievements/rectifyApi.js';
import { filePreview } from '@/utils/filePreview.js';
export default {
    components: { Upload, mSelect },
    props: {
        isSubmitDialog: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        isAction: {
            // 提交为true,查看为false
            type: Boolean,
            default: function () {
                return false;
            }
        },
        row: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            loadConfirm: false,
            form: { taskMethod: '' },
            rules: {
                taskMethod: {
                    required: true,
                    message: '请输入整改方法',
                    trigger: 'change'
                }
            },
            fileTableData: [],
            fileNameList: []
        };
    },
    mounted() {
        if (!this.isAction || this.row.taskStatus === '3') {
            this.fileList();
            this.form.taskMethod = this.row.remark;
        }
    },
    methods: {
        confirm() {
            this.fileTableData.forEach((item) => {
                const obj = {
                    fileName: item.fileName,
                    moduleNo: this.row.rectificationNo,
                    fileUrl: item.downUrl,
                    fileId: item.id
                };
                this.fileNameList.push(obj);
            });
            this.$refs['form'].validate(async (valid) => {
                if (valid) {
                    if (this.fileTableData.length !== 0) {
                        this.loadConfirm = true;
                        const res = await rectifySubmit({
                            taskMethod: this.form.taskMethod,
                            id: this.row.id,
                            moduleFileDtos: this.fileNameList,
                            version: this.row.version,
                            remark: this.row.remark,
                            taskStatus: '2'
                        });
                        this.loadConfirm = false;
                        if (res) {
                            this.$message.success('操作成功');
                            this.$emit('submitSuccess');
                        }
                    } else {
                        this.$message.warning('请上传证明文件');
                    }
                }
            });
        },
        closeDialog() {
            this.$emit('update:isSubmitDialog', false);
        },
        async fileList() {
            const fileData = await fileList({
                moduleType: 'JX_3',
                moduleNo: this.row.rectificationNo
            });
            if (fileData && fileData.data) {
                this.fileTableData = fileData.data.list;
            }
        },
        uploadSuccess(res) {
            const type = res.data.data.downUrl.split('.').pop();
            res.data.data.fileName = res.data.data.localFileName.split('_')[0] + '.' + type;
            res.data.data.fileUrl = res.data.data.downUrl;
            this.fileTableData = this.fileTableData.concat([res.data.data]);
        },
        previewBtn(row) {
            if (this.isAction) {
                // 提交
                row.fileId = null;
                row.fileUrl = row.fileUrl.replace(/https/, 'http');
            }
            filePreview(row);
        },
        // 文件下载
        downloadBtn(row) {
            const url = row.downUrl || row.fileUrl;
            window.open(url, '_parent');
        },
        // 文件删除
        delBtn(row, index) {
            this.fileTableData.splice(index, 1);
        }
    }
};
</script>
<style lang="less">
.rectify-submit-dialog {
    .tip-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .examine-table-title {
        font-size: 14px;
        color: #333333;
    }
    .iconicon_export {
        color: #00bcbf;
        cursor: pointer;
    }
    .tab-tbn {
        margin-right: 15px;
    }
    .dict-select {
        .el-input__suffix {
            display: none;
        }
        .el-input__inner {
            border: 0;
            color: #666;
            cursor: auto !important;
            background-color: hsla(0, 0%, 100%, 0);
        }
    }
}
</style>